import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

@Entity({one: "user"})
export class User {
	@Field() public id: ID;
	@Field() public firstName: string;
	@Field() public lastName: string;
	@Field() public email: string;
}



// WEBPACK FOOTER //
// ./src/panels/userProfile/entities/User.ts